export default __webpack_public_path__ + "static/media/vehicle-crash-cul.2a7bb0f1.png";